'use client'

import { createContext, useContext, useState, ReactNode } from 'react'

import { TVesselJourneyResponse } from '@/api/v1/resources/vesselJourney'

type TActiveVesselContext = {
  activeVessel: TVesselJourneyResponse | null
  setActiveVessel: (vessel: TVesselJourneyResponse | null) => void
}

const ActiveVesselContext = createContext<TActiveVesselContext | undefined>(undefined)

type Props = {
  children: ReactNode
}

export function ActiveVesselProvider({ children }: Props) {
  const [activeVessel, setActiveVessel] = useState<TVesselJourneyResponse | null>(null)

  return (
    <ActiveVesselContext.Provider value={{ activeVessel, setActiveVessel }}>
      {children}
    </ActiveVesselContext.Provider>
  )
}

export function useActiveVessel() {
  const context = useContext(ActiveVesselContext)
  if (!context) {
    throw new Error('useActiveVessel must be used within ActiveVesselProvider')
  }
  return context
}
